import { useState } from 'react';
import { faqData } from '@/mocks/articles';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="py-16 md:py-24 px-6 md:px-10 bg-background-50">
      <div className="max-w-[800px] mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-flex items-center px-4 py-1.5 rounded-full border border-accent-300 bg-accent-100/60 text-xs font-semibold text-accent-800 uppercase tracking-wide mb-4">
            FAQ
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-extrabold text-foreground-950 leading-tight tracking-tight">
            Frequently Asked<br />Questions
          </h2>
        </div>

        <div className="space-y-3">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="rounded-xl border border-background-200/70 bg-background-50 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer hover:bg-background-100 transition-colors"
              >
                <span className="text-sm md:text-base font-semibold text-foreground-950 pr-4">
                  {faq.question}
                </span>
                <span className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-45' : ''}`}>
                  <i className="ri-add-line text-foreground-500" />
                </span>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === index ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}